import React from 'react'
import PropTypes from 'prop-types'
import { MultiSelect, MultiOption, CountryLegend, FormLabel } from '@offerzen/pinata'

import styles from './styles'

const compareCountries = (a, b) => {
  const parsedA = a.name.toUpperCase()
  const parsedB = b.name.toUpperCase()
  if (parsedA < parsedB) {
    return -1
  }
  if (parsedB > parsedA) {
    return 1
  }
  return 0
}

const CityMultiSelect = ({ id, name, label, value, onSelect, countries, className, ...props }) => {
  const labelId = `${id}-label`
  const sortedCountries = countries.sort(compareCountries)

  return (
    <div className={className} data-testid={`${id}-testid`}>
      <FormLabel label={label} id={labelId} />
      <MultiSelect
        id={id}
        name={name}
        ariaLabelledby={labelId}
        placeholder="Select cities"
        label="Selected cities"
        value={value}
        onSelect={onSelect}
        className={styles.select}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}>
        <For each="country" of={sortedCountries}>
          <li role="presentation" className={styles.sectionHeading}>
            <CountryLegend countryCode={country.code} countryName={country.name} />
          </li>

          <For each="city" of={country.cities}>
            <MultiOption id={city.id} label={city.name} name={city.name} key={city.id} />
          </For>
        </For>
      </MultiSelect>
    </div>
  )
}

CityMultiSelect.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      code: PropTypes.string,
      cities: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  className: PropTypes.string,
}

export default CityMultiSelect
